import React, { useState } from "react";
import { CrownOutlined, CloseCircleOutlined, PlusCircleOutlined, DownOutlined, CaretDownOutlined } from "@ant-design/icons";
import { Collapse, Tabs, Tooltip, Typography } from "antd";
import * as RankApi from '../../../api/rank/rankApi';
import { gold_image, noData } from "../../../components/ExportImgFigma";
import RightPopup from "../../../components/Popup/RightPopup";
import { URL_RANK } from "../../../env";
import { formatNumber } from "../../../services/mixin";
import './ShowRank.scss';

interface BenefitItem {
  id: number;
  title: string;
  description?: string;
}

const BenefitList: React.FC<{ items: BenefitItem[] }> = ({ items }) => {
  const [expandedIds, setExpandedIds] = useState<number[]>([]);

  const toggle = (id: number) => {
    setExpandedIds(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  return (
    <div className="benefit-list">
      {items.length > 0 ? items.map(item => {
        const isExpanded = expandedIds.includes(item.id);
        return (
          <div
            key={item.id}
            className={`benefit-list__item${isExpanded ? ' benefit-list__item--expanded' : ''}`}
          >
            <div className="benefit-list__item-header">
              <div className="benefit-list__item-title "
                style={{
                  width: '80%'
                }}>
                <CrownOutlined className="benefit-list__item-icon" />
                <Tooltip
                  title={
                    <span className="font-regular "

                    >{item.title}</span>
                  }
                >
                  <span className="font-regular text-truncate"
                  >{item.title}</span>
                </Tooltip>

              </div>
              <button
                className="benefit-list__item-btn"
                onClick={() => toggle(item.id)}
              >
                {isExpanded
                  ? <CloseCircleOutlined className="btn-icon btn-icon--close" />
                  : <PlusCircleOutlined className="btn-icon btn-icon--plus" />
                }
              </button>
            </div>
            {isExpanded && item.description && (
              <div className="benefit-list__item-desc">{item.description}</div>
            )}
          </div>
        );
      })
        :
        <div
          style={{
            textAlign: 'center',
            padding: 20
          }}>
          <br />
          <img src={noData} alt="No data"

            style={{
              maxWidth: 150,
            }} />
          <br />
          <div>Không có dữ liệu</div>
          <br />
        </div>
      }
    </div>
  );
};

const BenefitListV2: React.FC<{ items: RankApi.ICarePolicy[] }> = ({ items }) => {
  const [expandedIds, setExpandedIds] = useState<number[]>([]);

  const toggle = (id: number) => {
    setExpandedIds(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  return (
    <div className="benefit-list">
      {items.length > 0 ? items.map(item => {
        const isExpanded = expandedIds.includes(item.id);
        return (
          <div
            key={item.id}
            className={`benefit-list__item${isExpanded ? ' benefit-list__item--expanded' : ''}`}
          >
            <div className="benefit-list__item-header">
              <div className="benefit-list__item-title "
                style={{
                  width: '80%'
                }}>
                <CrownOutlined className="benefit-list__item-icon" />
                <Tooltip
                  title={
                    <span className="font-regular "

                    >{item.title}</span>
                  }
                >
                  <span className="font-regular text-truncate"
                  >{item.title}</span>
                </Tooltip>

              </div>
              <button
                className="benefit-list__item-btn"
                onClick={() => toggle(item.id)}
              >
                {isExpanded
                  ? <CloseCircleOutlined className="btn-icon btn-icon--close" />
                  : <PlusCircleOutlined className="btn-icon btn-icon--plus" />
                }
              </button>
            </div>
            {
              isExpanded && (
                <div className="">
                  <div className="custome-page-css flex items-center  gap-2">
                    <span>Ngày bắt đầu:</span>
                    <span>{item.dateStart}</span>
                  </div>

                  <div className="custome-page-css flex items-center  gap-2">
                    <span>Ngày kết thúc:</span>
                    <span>{item.dateEnd}</span>
                  </div>

                  <div className="custome-page-css flex items-center  gap-2">
                    <span>Áp dụng thương hiệu xe sở hữu:</span>
                    <span>{item.brands}</span>
                  </div>

                  <div className="custome-page-css flex items-center  gap-2 pb-4">
                    <span className="custome-page-css no-wrap">Áp dụng tên xe sở hữu:</span>
                    <Typography.Paragraph
                      style={{
                        marginBottom: 0
                      }}
                      ellipsis={{
                        rows: 1,
                        tooltip: item.cars
                      }}
                    >
                      {item.cars}
                    </Typography.Paragraph>
                  </div>
                  {/* {items.map(item => */}

                  <CarePolicyCard
                    key={item.id}
                    item={item}
                  />

                  {/* )} */}

                </div>
              )}
          </div>
        );
      })
        :
        <div
          style={{
            textAlign: 'center',
            padding: 20
          }}>
          <br />
          <img src={noData} alt="No data"

            style={{
              maxWidth: 150,
            }} />
          <br />
          <div>Không có dữ liệu</div>
          <br />
        </div>
      }
    </div>
  );
};

interface CarePolicyCardProps {
  item: RankApi.ICarePolicy;
}

const CarePolicyCard: React.FC<CarePolicyCardProps> = ({ item }) => {

  const [open, setOpen] = useState(true);

  return (

    <div className="care-policy-card care-policy-collapse">

      <Collapse
        className=""
        expandIconPosition="end"
        ghost
        activeKey={open ? ['1'] : []}
        expandIcon={({ isActive }) => (
          <CaretDownOutlined 
            rotate={isActive ? 180 : 0}
            style={{
              fontSize: 14,
              color: "#98A2B3",
              transition: "all .2s",
            }}
          />
        )}
        onChange={() => setOpen(!open)}
        items={[
          {
            key: "1",
            label: `Quyền lợi chính sách CSKH đi kèm (${item.benefitPolicies.length})`,
            children:
              item.benefitPolicies.map(x => (
                <div
                  key={x.id}
                  className="pb-1"
                >
                  {x.title}
                </div>
              ))
          }
        ]}
      />

    </div>

  )
}



interface Props {
  className?: string;
  onClose?: () => void;
  dataBenefitRank?: RankApi.IInfoRank
}

const ShowRank: React.FC<Props> = ({ className, dataBenefitRank, onClose }) => {
  const handleOnClose = () => {
    if (onClose) onClose();
  };

  const benefits: BenefitItem[] = dataBenefitRank?.benefits ?? [];
  const carePolicies: RankApi.ICarePolicy[] = dataBenefitRank?.carePolicies ?? [];
  const benefitPolicies: BenefitItem[] = dataBenefitRank?.benefitPolicies ?? [];

  return (
    <RightPopup
      title="Chi tiết"
      className={className}
      contentClassName="user-card-popup__content"
      onClose={handleOnClose}
    >
      <div className="detail-rank-section">
        <div className="detail-rank-section__row">
          <span className="detail-rank-section__label">Hạng</span>
          <div className="detail-rank-section__rank">
            <img
              src={URL_RANK + dataBenefitRank?.icon}
              alt={dataBenefitRank?.title}
              className="detail-rank-section__rank-icon"
              onError={(e) => { e.currentTarget.src = gold_image; }}
            />
            <span className="detail-rank-section__rank-name">{dataBenefitRank?.title}</span>
          </div>
        </div>
        {dataBenefitRank?.totalAmount !== undefined && (
          <div className="detail-rank-section__desc">
            Cần tổng chi tiêu tối thiểu {formatNumber(dataBenefitRank?.totalAmount)}đ để đạt hạng này
          </div>
        )}
      </div>

      <Tabs
        className="detail-rank-tabs"
        items={[
          {
            key: '1',
            label: `Quyền lợi hạng (${benefits.length})`,
            children: <BenefitList items={benefits} />,
          },
          {
            key: '2',
            label: `Chính sách CSKH (${carePolicies.length})`,
            children: <BenefitListV2 items={carePolicies} />,
          },
          {
            key: '3',
            label: `Quyền lợi chính sách CSKH (${benefitPolicies.length})`,
            children: <BenefitList items={benefitPolicies} />,
          },
        ]}
      />
    </RightPopup>
  );
};

export default ShowRank;


